import { useCallback } from 'react';
import { useActions } from 'lib/hooks';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadAppleWalletPassErrorModalProps } from './DownloadAppleWalletPassErrorModal';

export const useDownloadAppleWalletPassErrorModal = () => {
  const actions = useActions();

  return useCallback(() => {
    track.appleWalletPassDownloadFailedModalOpened();
    actions.modal.setupModal({
      ...downloadAppleWalletPassErrorModalProps,
      isOpen: true,
      onClose: ({ actionButtonClicked }) => {
        track.appleWalletPassDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [actions.modal]);
};
